import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Session from 'interview/components/sequenced-interview/session'
import Publisher from 'interview/components/sequenced-interview/publisher'
import Retakes from './retakes'
import styled from 'styled-components'
import { Flex } from 'components/styled/containers/flex'
import { timedInterviewAutomaticSubmitAndMoveForward } from 'flags'
import SubmitTimer from './submit-timer'
import { Subtitle } from 'components/styled/typography'
import { mapLanguageToComponentProps } from 'interview/i18n'

const propTypes = {
  testing: PropTypes.bool,
  onStop: PropTypes.func,
  submitting: PropTypes.bool,
  hasError: PropTypes.bool,
  onRetake: PropTypes.func,
  onSubmit: PropTypes.func,
  timerCount: PropTypes.number,
  totalTime: PropTypes.number,
  onAnswer: PropTypes.bool,
  candidateUuid: PropTypes.string,
  nextQuestion: PropTypes.shape({}),
  answerTimeInfo: PropTypes.string,
  questionView: PropTypes.bool,
  stopped: PropTypes.bool,
  reconnecting: PropTypes.bool,
  streaming: PropTypes.bool,
  publisher: PropTypes.shape({}),
}

const defaultProps = {
  candidateUuid: undefined,
  onStop: undefined,
  onRetake: undefined,
  onSubmit: undefined,
  testing: false,
  submitting: false,
  hasError: false,
  onAnswer: false,
  timerCount: 0,
  totalTime: 0,
  nextQuestion: undefined,
  answerTimeInfo: undefined,
  questionView: false,
  stopped: false,
  reconnecting: false,
  streaming: false,
  publisher: undefined,
}

const StreamContainer = styled.div`
  display: ${props => props.$hidden && 'none'};
  width: 100%;
`
export function StreamView({
  testing,
  onStop,
  stopped,
  reconnecting,
  submitting,
  hasError,
  onRetake,
  onSubmit,
  timerCount,
  totalTime,
  onAnswer,
  candidateUuid,
  nextQuestion,
  answerTimeInfo,
  questionView,
  streaming,
  publisher,
}) {
  const renderRetakes = !!(
    !submitting &&
    !questionView &&
    onAnswer &&
    !reconnecting
  )
  const renderActions = !!(!hasError && !testing && streaming && publisher)
  const isOnPrep = !onAnswer && !testing
  const streamContainerRef = React.useRef(null)

  useEffect(() => {
    if (streamContainerRef && streamContainerRef.current) {
      streamContainerRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])
  return (
    <Flex
      mt="s24"
      mb="s24"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Session testing={testing} candidateUuid={candidateUuid} />
      <StreamContainer ref={streamContainerRef} $hidden={questionView}>
        <Publisher
          testing={testing}
          timerCount={timerCount}
          totalTime={totalTime}
          prep={isOnPrep}
          submitting={submitting}
          lastQuestion={typeof nextQuestion !== 'object'}
          onSubmit={onSubmit}
          onStop={() => onStop(true)}
        >
          {renderActions &&
            renderRetakes &&
            stopped &&
            timedInterviewAutomaticSubmitAndMoveForward() && (
              <SubmitTimer onSubmit={onSubmit} />
            )}
        </Publisher>
        {renderActions && isOnPrep && answerTimeInfo && (
          <Subtitle mt="s16">{answerTimeInfo}</Subtitle>
        )}
        {renderActions && renderRetakes && (
          <Retakes onRetake={onRetake} onSubmit={onSubmit} />
        )}
      </StreamContainer>
    </Flex>
  )
}

StreamView.propTypes = propTypes
StreamView.defaultProps = defaultProps

export default StreamView
